import * as ConnectionType from '../constants/ConnectionType';
export const baseOffering = {
  credentials: [],
  connectionType: ConnectionType.STANDARD,
  firstPublishedAt: 0,
  homemade: false,
  installsCount: 0,
  slug: '',
  sourceId: '',
  portalId: 0
};